import React, { Children, SyntheticEvent, useEffect, useState } from 'react';
import { useTranslations } from 'hooks/useTranslations';
import { Box, Typography } from '@mui/material';
import { StyledTab, StyledTabs } from './styles';
import { colors } from 'theme/colors';
import { useThemeBreakpoint } from 'hooks/useThemeBreakpoint';
import TabPanel from './TabPanel';

export interface Tab {
  name?: string;
  title: string;
  content: React.ReactNode;
  hideIfOneTab?: boolean;
}

interface TabMenuProps {
  tabs: Tab[];
  defaultTab?: number;
  onChangeTab?: (tabName: any) => void;
  hideIfOneTab?: boolean;
}

const TabMenu: React.FC<TabMenuProps> = ({
  tabs,
  defaultTab = 0,
  onChangeTab,
  hideIfOneTab = false,
}) => {
  const { isDesktop } = useThemeBreakpoint();
  const { t } = useTranslations();
  const [value, setValue] = useState(defaultTab);

  useEffect(() => {
    setValue(defaultTab);
  }, [defaultTab]);

  const handleChange = (event: SyntheticEvent, newValue: number) => {
    setValue(newValue);
    if (onChangeTab) {
      onChangeTab(tabs[newValue].name);
    }
  };

  return (
    <Box sx={{ my: '20px' }}>
      {isDesktop && (tabs.length > 1 || !hideIfOneTab) && (
        <StyledTabs value={value} onChange={handleChange} variant="fullWidth">
          {tabs.map((tab, index) => (
            <StyledTab
              key={index}
              label={
                <Typography variant="subtitle1" sx={{ color: colors.primary900 }}>
                  {t(tab.title)}
                </Typography>
              }
            />
          ))}
        </StyledTabs>
      )}

      {tabs.map((tab, index) => (
        <TabPanel
          key={index}
          value={value}
          index={index}
          title={t(tab.title)}
          onChange={handleChange}
          isDesktop={isDesktop}
        >
          {tab.content}
        </TabPanel>
      ))}
    </Box>
  );
};

export { TabMenu };
